module.exports = __webpack_public_path__ + "static/hero-right-c9efd8e6cea49b229c3dfb6cc1b07bee.png";